<template>
  <div class="app-page">
    <HeaderDve ref="header" helpURL="studio/snapshots/">
      <template #header-slot>
        <BreadcrumbNavigation />
      </template>
    </HeaderDve>
    <div class="main-page-div">
      <main class="main-display-area">
        <SnapshotList />
      </main>
    </div>
    <TasksModal />
  </div>
</template>

<script>
import HeaderDve from '@/components/Header.vue';
import BreadcrumbNavigation from '@/components/BreadcrumbNavigation.vue';
import SnapshotList from '@/components/Snapshots/SnapshotList.vue';
import TasksModal from '@/components/TasksStatusComponent/TasksModalV2.vue';

export default {
  name: 'Snapshots',
  components: {
    TasksModal,
    HeaderDve,
    BreadcrumbNavigation,
    SnapshotList,
  },

};

</script>

<style lang="scss" scoped>
</style>
